export default __webpack_public_path__ + "static/media/1273.68c0fe74.png";